import React from "react";
import cx from "classnames";
import { Box, SkeletonBase } from "@foris/avocado-suite";
import styles from "./schedule.skeleton.module.scss";

interface ScheduleCalendarSkeletonProps {
  className?: string;
}

const ScheduleCalendarSkeleton = ({ className = "" }: ScheduleCalendarSkeletonProps) => {
  return (
    <section className={cx(styles.scheduleSkeleton, className && className)}>
      <SkeletonBase className={styles.navigator} width={260} height={30} />

      <Box className={styles.calendar}>
        <section className={styles.calendar_days}>
          {[...Array(7)].map((_, index) => (
            <SkeletonBase key={`calendar-days-${index}`} width="90%" height="12px" />
          ))}
        </section>
        <section className={styles.calendar_hours}>
          {[...Array(15)].map((_, index) => (
            <SkeletonBase key={`calendar-hour-${index}`} width="12px" height="12px" />
          ))}
        </section>
        <section className={styles.calendar_table}>
          {[...Array(7)].map((_, index) => (
            <ul
              key={`calendar-ul-${index}`}
              className={cx(styles.rows, "container_row", "row__between")}
            >
              {[...Array(15)].map((_, liIndex) => (
                <li key={`calendar-li-${liIndex}`} className={styles.rows_item} />
              ))}
            </ul>
          ))}
        </section>
      </Box>
    </section>
  );
};

export default ScheduleCalendarSkeleton;
